const body = document.body;
const header = document.querySelector(".site-header");
const menuButton = document.querySelector(".menu-button");
const mobileNav = document.querySelector(".mobile-nav");
const cartDrawer = document.querySelector(".cart-drawer");
const cartBackdrop = document.querySelector("[data-cart-backdrop]");
const cartContent = document.querySelector("[data-cart-content]");

function escapeHtml(value = "") {
  const element = document.createElement("div");
  element.textContent = value;
  return element.innerHTML;
}

function formatMoney(cents, format = window.moneyFormat || "${{amount}}") {
  const amount = (Number(cents) / 100).toFixed(2);
  return format
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(Number(cents) / 100))
    .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace(".", ","))
    .replace(/\{\{\s*amount\s*\}\}/, amount);
}

function setMenu(open) {
  if (!menuButton || !mobileNav) return;
  menuButton.setAttribute("aria-expanded", String(open));
  mobileNav.classList.toggle("open", open);
  body.classList.toggle("menu-open", open);
}

function setDrawer(open) {
  if (!cartDrawer || !cartBackdrop) return;
  cartDrawer.classList.toggle("open", open);
  cartDrawer.setAttribute("aria-hidden", String(!open));
  body.classList.toggle("drawer-open", open);
  cartBackdrop.hidden = !open;
  requestAnimationFrame(() => cartBackdrop.classList.toggle("visible", open));
  if (open) cartDrawer.querySelector("[data-cart-close]")?.focus();
}

function renderCart(cart) {
  document.querySelectorAll("[data-cart-count]").forEach((count) => {
    count.textContent = cart.item_count;
    count.setAttribute("aria-label", `${cart.item_count} item${cart.item_count === 1 ? "" : "s"} in shopping bag`);
  });

  if (!cartContent) return;

  if (cart.item_count === 0) {
    cartContent.innerHTML = `
      <div class="cart-empty">
        <p>Your bag is waiting for something fun.</p>
        <a class="button button-dark" href="/collections/all">Shop Best Sellers</a>
      </div>`;
    return;
  }

  const lines = cart.items
    .map(
      (item) => `
        <div class="cart-line" data-cart-line="${escapeHtml(item.key)}">
          ${item.image ? `<img src="${escapeHtml(item.image)}&width=220" alt="${escapeHtml(item.product_title)}">` : ""}
          <div>
            <p><a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a></p>
            ${item.variant_title ? `<small>${escapeHtml(item.variant_title)}</small>` : ""}
            <strong>${formatMoney(item.final_line_price)}</strong>
          </div>
          <button class="remove-item" type="button" data-cart-remove="${escapeHtml(item.key)}">Remove</button>
        </div>`
    )
    .join("");

  cartContent.innerHTML = `
    <div class="cart-filled">
      ${lines}
      <div class="cart-summary"><span>Subtotal</span><strong data-cart-subtotal>${formatMoney(cart.total_price)}</strong></div>
      <a class="button button-clay checkout-button" href="/cart">View Bag &amp; Checkout</a>
      <p class="checkout-note">Shipping and taxes are calculated at checkout</p>
    </div>`;
}

async function refreshCart() {
  const response = await fetch(window.routes.cart, { headers: { Accept: "application/json" } });
  const cart = await response.json();
  renderCart(cart);
  return cart;
}

menuButton?.addEventListener("click", () => {
  setMenu(menuButton.getAttribute("aria-expanded") !== "true");
});

mobileNav?.querySelectorAll("a").forEach((link) => link.addEventListener("click", () => setMenu(false)));

document.querySelectorAll("[data-cart-open]").forEach((button) => {
  button.addEventListener("click", async () => {
    await refreshCart();
    setDrawer(true);
  });
});

document.querySelector("[data-cart-close]")?.addEventListener("click", () => setDrawer(false));
cartBackdrop?.addEventListener("click", () => setDrawer(false));

document.addEventListener("click", async (event) => {
  const removeButton = event.target.closest("[data-cart-remove]");
  if (!removeButton) return;

  removeButton.disabled = true;
  await fetch(window.routes.cartChange, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ id: removeButton.dataset.cartRemove, quantity: 0 })
  });
  await refreshCart();
});

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape") {
    setDrawer(false);
    setMenu(false);
  }
});

document.querySelectorAll("[data-quantity-minus], [data-quantity-plus]").forEach((button) => {
  button.addEventListener("click", () => {
    const wrapper = button.closest(".quantity");
    const input = wrapper?.querySelector("[data-quantity-input]");
    if (!input) return;
    const change = button.hasAttribute("data-quantity-plus") ? 1 : -1;
    const maximum = Number(input.max || 99);
    input.value = Math.max(Number(input.min || 1), Math.min(maximum, Number(input.value || 1) + change));
  });
});

document.querySelectorAll("[data-variant-select]").forEach((select) => {
  select.addEventListener("change", () => {
    const option = select.options[select.selectedIndex];
    const productRoot = select.closest("[data-featured-product]");
    productRoot?.querySelectorAll("[data-product-price], [data-add-price]").forEach((price) => {
      price.textContent = option.dataset.price;
    });
  });
});

document.querySelectorAll(".shopify-product-form").forEach((form) => {
  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    const button = form.querySelector("[data-add-to-cart]");
    const label = form.querySelector("[data-add-label]");
    const originalLabel = label?.textContent;

    if (button) button.disabled = true;
    if (label) label.textContent = "Adding…";

    try {
      const response = await fetch(window.routes.cartAdd, {
        method: "POST",
        headers: { Accept: "application/json" },
        body: new FormData(form)
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.description || "This item could not be added.");
      }

      await refreshCart();
      setDrawer(true);
      if (label) label.textContent = "Added";
    } catch (error) {
      if (label) label.textContent = error.message;
    } finally {
      setTimeout(() => {
        if (label) label.textContent = originalLabel;
        if (button) button.disabled = false;
      }, 1600);
    }
  });
});

document.querySelectorAll(".faq-item button").forEach((button) => {
  button.addEventListener("click", () => {
    const item = button.closest(".faq-item");
    const wasOpen = item.classList.contains("open");
    item.closest(".accordion")?.querySelectorAll(".faq-item").forEach((faq) => {
      faq.classList.remove("open");
      faq.querySelector("button")?.setAttribute("aria-expanded", "false");
    });
    if (!wasOpen) {
      item.classList.add("open");
      button.setAttribute("aria-expanded", "true");
    }
  });
});

const dialog = document.querySelector("[data-image-dialog]");
const dialogImage = dialog?.querySelector("[data-dialog-image]");

document.querySelectorAll("[data-product-thumb]").forEach((thumb) => {
  thumb.addEventListener("click", () => {
    const gallery = thumb.closest(".product-gallery");
    gallery?.querySelectorAll("[data-product-thumb]").forEach((item) => item.classList.remove("active"));
    thumb.classList.add("active");
    const mainImage = gallery?.querySelector("[data-product-main-image]");
    if (mainImage) {
      mainImage.style.opacity = "0";
      setTimeout(() => {
        mainImage.src = thumb.dataset.image;
        mainImage.srcset = "";
        mainImage.alt = thumb.dataset.alt || "";
        mainImage.style.opacity = "1";
      }, 160);
    }
    if (dialogImage) {
      dialogImage.src = thumb.dataset.image;
      dialogImage.alt = thumb.dataset.alt || "";
    }
  });
});

document.querySelectorAll("[data-image-zoom]").forEach((button) => {
  button.addEventListener("click", () => {
    const mainImage = button.closest(".product-gallery")?.querySelector("[data-product-main-image]");
    if (mainImage && dialogImage) {
      dialogImage.src = mainImage.currentSrc || mainImage.src;
      dialogImage.alt = mainImage.alt;
    }
    if (typeof dialog?.showModal === "function") dialog.showModal();
  });
});

document.querySelector("[data-image-dialog-close]")?.addEventListener("click", () => dialog.close());
dialog?.addEventListener("click", (event) => {
  if (event.target === dialog) dialog.close();
});

document.querySelectorAll(".range-option").forEach((button) => {
  button.addEventListener("click", () => {
    const length = Number(button.dataset.length);
    const reach = length === 16 ? 38 : length === 29 ? 58 : 76;
    button.closest(".range-controls")?.querySelectorAll(".range-option").forEach((item) => item.classList.remove("active"));
    button.classList.add("active");
    document.querySelector(".wand")?.style.setProperty("--reach", `${reach}%`);
    const value = document.querySelector(".measure-value");
    if (value) value.textContent = length;
  });
});

if ("IntersectionObserver" in window) {
  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
          revealObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1 }
  );
  document.querySelectorAll(".reveal").forEach((element) => revealObserver.observe(element));
} else {
  document.querySelectorAll(".reveal").forEach((element) => element.classList.add("visible"));
}

window.addEventListener("scroll", () => header?.classList.toggle("scrolled", window.scrollY > 20), { passive: true });
